import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "masthead" }


import TitleBar, { TitleBarProps } from '@shell/components/Resource/Detail/TitleBar/index.vue';
import Metadata, { MetadataProps } from '@shell/components/Resource/Detail/Metadata/index.vue';
import Cards from '@shell/components/Resource/Detail/Cards.vue';
import FleetManagedBanner from '@shell/components/Resource/Detail/FleetManagedBanner.vue';
import FleetManagedBadge from '@shell/components/Resource/Detail/FleetManagedBadge.vue';

export interface MastheadProps {
  titleBarProps?: TitleBarProps;
  metadataProps?: MetadataProps;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    titleBarProps: {},
    metadataProps: {}
  },
  setup(__props: any) {

const props = __props;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (props.titleBarProps)
      ? (_openBlock(), _createBlock(TitleBar, _normalizeProps(_mergeProps({ key: 0 }, props.titleBarProps)), _createSlots({
          "title-suffix": _withCtx(() => [
            _createVNode(FleetManagedBadge, {
              resource: props.titleBarProps.resource
            }, null, 8, ["resource"]),
            _cache[0] || (_cache[0] = _createTextVNode()),
            _renderSlot(_ctx.$slots, "title-suffix")
          ]),
          _: 2
        }, [
          (_ctx.$slots['additional-actions'])
            ? {
                name: "additional-actions",
                fn: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "additional-actions")
                ]),
                key: "0"
              }
            : undefined
        ]), 1040))
      : _createCommentVNode("", true),
    _cache[2] || (_cache[2] = _createTextVNode()),
    _renderSlot(_ctx.$slots, "banner"),
    _cache[3] || (_cache[3] = _createTextVNode()),
    (props.titleBarProps)
      ? (_openBlock(), _createBlock(FleetManagedBanner, {
          key: 1,
          class: "fleet-managed-banner",
          resource: props.titleBarProps.resource
        }, null, 8, ["resource"]))
      : _createCommentVNode("", true),
    _cache[4] || (_cache[4] = _createTextVNode()),
    (props.metadataProps)
      ? (_openBlock(), _createBlock(Metadata, _mergeProps({
          key: 2,
          class: "metadata-section"
        }, props.metadataProps), null, 16))
      : _createCommentVNode("", true),
    _cache[5] || (_cache[5] = _createTextVNode()),
    (props.titleBarProps)
      ? (_openBlock(), _createBlock(Cards, {
          key: 3,
          class: "cards-section",
          resource: props.titleBarProps.resource
        }, null, 8, ["resource"]))
      : _createCommentVNode("", true)
  ]))
}
}

})